const state = {
  text: "",
  status: 0,
  requaredField: false,
  linkList: [],
  imageList: []
};

const getters = {};

const actions = {};

const mutations = {
  clearTextEditorText(state) {
    state.text = "";
    state.status = 0;
    state.requaredField = false;
    state.linkList = [];
    state.imageList = [];
  },
  setTextEditorText(state, text) {
    state.text = text;
  },
  setTextEditorStatus(state, status) {
    state.status = status;
  },
  setRequaredField(state, val) {
    state.requaredField = val;
  },
  setLinkList(state, list) {
    state.linkList = list;
  },
  setImageList(state, list) {
    state.imageList = list;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
